import * as React from 'react';
import { ApiStore } from '../../../stores/ApiStore';
import { inject } from '../../../utils/decorators';
import { Panel } from 'react-bootstrap';
import FaIcon from '../../site/FaIcon';

interface IFormularElementUrl {
  text: string;
  url: string;
  target: string;
  icon?: string;
  tokenErfoderlich: boolean;
}

export default class FormularElementUrl extends React.Component<IFormularElementUrl, {}> {

  @inject(ApiStore) apiStore: ApiStore;

  render() {
    var url = this.props.url;
    if (this.props.tokenErfoderlich) {
      url = url + `?token=${this.apiStore.token}`;
    }
    const { target, text } = this.props;
    const icon = this.props.icon ? this.props.icon : 'lightbulb-o';
    return (
      <Panel className="formular-element-url" onClick={() => window.open(url, target)}>
        <div className="text-center">
        <div style={{fontSize: '1.5em'}}><FaIcon icon={icon} /></div>
          <div>{text}</div>
        </div>
      </Panel>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/formularelemente/FormularElementUrl.tsx